import { render } from "./Univ.vue?vue&type=template&id=a32ccf1a&scoped=true"
import script from "./Univ.vue?vue&type=script&lang=js"
export * from "./Univ.vue?vue&type=script&lang=js"

import "./Univ.vue?vue&type=style&index=0&id=a32ccf1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a32ccf1a"

export default script